const links = [

{
    id:"1",
    name: "Visit my portfolio site",
    url:"https://mighty-taiga-79136.herokuapp.com/",
    iconn: "fas fa-globe-africa"
    
},

{
    id:"2",
    name: "Let's chat on twitter",
    url:"https://twitter.com/tmaty_",
    iconn: "fab fa-twitter"
    
},

{
    id:"3",
    name: "View career updates",
    url:"https://www.linkedin.com/in/thato-matabane-7185381ba",
    iconn: "fab fa-linkedin"
},

{
    id:"4",
    name: "Check out this lintree's code",
    url:"https://github.com/tmatabane/linktree/tree/master",
    iconn: "fab fa-github"
}

];

export default links;